import React from 'react'
import { OpenPreviewButton as SharedOpenPreviewButton } from '../OpenPreviewButton'
import { useBlogItemContext } from './Context'

export const OpenPreviewButton = () => {
  const { document, documentResult, loading } = useBlogItemContext()

  return (
    <SharedOpenPreviewButton
      blogId={document?._id ?? ''}
      slug={document?.slug ?? ''}
      disabled={loading || !document?._id}
      onSlugSaved={() => documentResult?.refetch?.()}
    />
  )
}
